/* SelmaCilek favoriler — Growave Wishlist köprüsü (1 Eki). Her sayfada snippets/header-icons.liquid ile yüklenir (defer).
   Growave kendi düğmelerini gizli "placeholder" kutularına (açık shadow root) çizer:
     ürün sayfası / kart: [data-in-wishlist="true|false"] düğmesi
     başlık:              a.gw-wl-go-to-wishlist-header-widget [data-items-count] (href = Growave favoriler sayfası)
   Görünür düğmeler bizim (ince çizgili 18px kalp): tıklama Growave düğmesine iletilir, durum (dolu kalp, aria-pressed,
   "Add to favorites" / "Remove from favorites") Growave'in data-in-wishlist özniteliğinden okunur.
   Growave'de Wishlist kapalıysa ya da uygulama yüklenmezse placeholder boş kalır → kalpler gizli kalır (hidden).
   İşaretleme (aynı kapsayıcıda):
     <button data-sc-fav-btn hidden …>  +  <div class="sc-gwh" aria-hidden="true"><div class="gw-…-placeholder" …></div></div>
     <a data-sc-wl hidden …><span class="sc-hdr-wl__n" hidden></span></a>  +  <div class="sc-gwh"><div class="gw-wl-header-icon-placeholder"></div></div>
   Sonradan eklenen kartlar (filtre, sayfalama, önerilenler) MutationObserver ile yakalanır. */
(function () {
  'use strict';
  if (window.__scFav) return;
  window.__scFav = true;

  var ADD = 'Add to favorites', REM = 'Remove from favorites';
  var GW_FAV = '[data-in-wishlist]';
  var GW_HDR = '.gw-wl-go-to-wishlist-header-widget, a[data-items-count]';
  var items = [];

  function gwFind(ph, sel) {
    if (!ph) return null;
    return (ph.shadowRoot && ph.shadowRoot.querySelector(sel)) || ph.querySelector(sel);
  }
  function placeholder(el) {
    var p = el.parentNode;
    return p ? p.querySelector('.sc-gwh > div') : null;
  }

  // --- kalp (ürün sayfası + kartlar)
  function setFav(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? REM : ADD);
  }
  function syncFav(it) {
    var g = gwFind(it.ph, GW_FAV);
    if (!g) return false;
    if (g.getAttribute('tabindex') !== '-1') { try { g.setAttribute('tabindex', '-1'); } catch (e) {} }
    var on = g.getAttribute('data-in-wishlist') === 'true';
    if (it.busy && on !== it.was) { it.busy = false; clearTimeout(it.t); }
    if (!it.busy) setFav(it.el, on);
    if (!it.ready) { it.ready = true; watch(it); it.el.hidden = false; }
    return true;
  }
  function onFav(e, it) {
    e.preventDefault();
    e.stopPropagation();
    var g = gwFind(it.ph, GW_FAV);
    if (!g) return;
    var on = g.getAttribute('data-in-wishlist') === 'true';
    it.busy = true;
    it.was = on;
    setFav(it.el, !on);
    clearTimeout(it.t);
    // Growave cevap vermezse (ör. misafirden e-posta istendi ve kapatıldı) gerçek duruma dön
    it.t = setTimeout(function () { it.busy = false; syncFav(it); }, 8000);
    g.click();
  }

  // --- başlıktaki kalp + sayı
  function syncHdr(it) {
    var a = gwFind(it.ph, GW_HDR);
    if (!a) return false;
    var href = a.getAttribute('href');
    if (href) it.el.setAttribute('href', href);
    var n = parseInt(a.getAttribute('data-items-count'), 10) || 0;
    var b = it.el.querySelector('.sc-hdr-wl__n');
    if (b) { b.textContent = n > 99 ? '99+' : String(n); b.hidden = n < 1; }
    it.el.setAttribute('aria-label', n > 0 ? 'Favorites (' + n + ')' : 'Favorites');
    if (!it.ready) { it.ready = true; watch(it); it.el.hidden = false; }
    return true;
  }
  // Tıklayınca Growave'in favoriler çekmecesi açılır; çekmece yoksa / açılmazsa Growave'in favoriler sayfasına gidilir.
  function onHdr(e, it) {
    var a = gwFind(it.ph, GW_HDR);
    if (!a) return; // Growave hazır değil: bağlantının kendi adresi
    e.preventDefault();
    var href = a.getAttribute('href') || it.el.getAttribute('href');
    var done = false;
    var go = function () { if (done) return; done = true; window.location.href = href; };
    var sdk = window.gw && window.gw.sdk;
    if (!sdk || typeof sdk.runIfModuleReady !== 'function') { go(); return; }
    var guard = setTimeout(go, 2500);
    try {
      var mod = (sdk.common && sdk.common.constants && sdk.common.constants.modules && sdk.common.constants.modules.WISHLISTS) || 'WishlistsSdk';
      sdk.runIfModuleReady(mod, function () {
        try {
          var m = sdk.wishlists && sdk.wishlists.methods;
          if (!m || typeof m.openWishlistsDrawer !== 'function') { clearTimeout(guard); go(); return; }
          Promise.resolve(m.openWishlistsDrawer()).then(function () { clearTimeout(guard); done = true; }, function () { clearTimeout(guard); go(); });
        } catch (err) { clearTimeout(guard); go(); }
      });
    } catch (err) { clearTimeout(guard); go(); }
  }

  // Growave düğmeyi yeniden çizerse / durum değişirse (başka sekme, çekmeceden silme) güncelle
  function watch(it) {
    if (!window.MutationObserver) return;
    var root = it.ph.shadowRoot || it.ph;
    new MutationObserver(function () { if (it.el.isConnected) (it.hdr ? syncHdr : syncFav)(it); })
      .observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-in-wishlist', 'data-items-count', 'href'] });
  }

  function add(el, hdr) {
    if (el.__scFav) return;
    var ph = placeholder(el);
    if (!ph) return;
    el.__scFav = true;
    var it = { el: el, ph: ph, hdr: hdr, ready: false, busy: false };
    el.addEventListener('click', function (e) { (hdr ? onHdr : onFav)(e, it); });
    items.push(it);
  }
  function collect(root) {
    if (!root || !root.querySelectorAll) return;
    var i, l = root.querySelectorAll('[data-sc-fav-btn]');
    for (i = 0; i < l.length; i++) add(l[i], false);
    l = root.querySelectorAll('[data-sc-wl]');
    for (i = 0; i < l.length; i++) add(l[i], true);
    if (root.matches && root.matches('[data-sc-fav-btn]')) add(root, false);
    kick();
  }

  // Growave yüklenene kadar bekle: önce sık, sonra seyrek; ~45 sn sonra vazgeç (Wishlist kapalıysa kalpler gizli kalır)
  var timer = 0, tries = 0;
  function tick() {
    timer = 0;
    var left = 0;
    items = items.filter(function (it) { return it.el.isConnected; });
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.ready && !(it.hdr ? syncHdr(it) : syncFav(it))) left++;
    }
    if (left && tries < 60) { tries++; timer = setTimeout(tick, tries < 20 ? 250 : 1000); }
  }
  function kick() {
    tries = 0;
    if (!timer) timer = setTimeout(tick, 50);
  }

  function start() {
    collect(document);
    document.addEventListener('gwSdkReady', kick);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var a = muts[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType === 1 && (n.matches('[data-sc-fav-btn],[data-sc-wl]') || n.querySelector('[data-sc-fav-btn],[data-sc-wl]'))) collect(n.parentNode || n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { collect(e.target); });
})();
